
import { Gait } from "../sim/movement";

/** `strideMm` of the player's `walk` clip. See the module doc for the source. */
export const PLAYER_WALK_STRIDE_MM = 1_768.6;
/** `strideMm` of the player's `run` clip. See the module doc for the source. */
export const PLAYER_RUN_STRIDE_MM = 3_000;

export class FootstepTracker {
  private progressMm = 0;

  advance(distanceMm: number, gait: Gait, dtMs: number, maxRunMmS: number): number {
    const maxPlausibleMm = (maxRunMmS * dtMs) / 1000 + PLAYER_RUN_STRIDE_MM;
    if (distanceMm > maxPlausibleMm || gait === Gait.IDLE) {
      this.progressMm = 0;
      return 0;
    }

    this.progressMm += distanceMm;
    const footfallMm = (gait === Gait.RUN ? PLAYER_RUN_STRIDE_MM : PLAYER_WALK_STRIDE_MM) / 2;

    let steps = 0;
    while (this.progressMm >= footfallMm) {
      this.progressMm -= footfallMm;
      steps++;
    }
    return steps;
  }

  /** For tests: distance banked since the last footfall. */
  get progress(): number {
    return this.progressMm;
  }
}
